module.exports = __webpack_public_path__ + "static/xy-histogram-with-mean-aggregation-251faa0d050a187d4c7c6bd796daebf5.png";